module.exports = __webpack_public_path__ + "static/media/icon-food.02a2f7b7.svg";